import enumBase from '@/enums/EnumBase';

export default class PlanName extends enumBase {
  static values = [
    { value: 'free', label: 'freePlan' },
    { value: 'basic', label: 'basicPlan' },
    { value: 'essential', label: 'essentialPlan' },
    { value: 'advanced', label: 'advancedPlan' },
  ];

  static normalize(name) {
    return name
      ?.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  static getByPlanName(name) {
    const normalizedName = this.normalize(name);
    const item = this.values.find((i) => i.value === normalizedName);
    return item ? `pages.planDetails.planNames.${item.label}` : name;
  }
}
